import { GdprReportsRepository, GdprActionsRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _serviceDependencies = ['$scope', '$state', 'GdprActionsRestService', 'Util', '$rootScope'];

class GdprReport {

    constructor($scope, $state, GdprActionsRestService, Util, $rootScope) {

        const GdprReports = GdprReportsRepository.getAll();
        $scope.finalReport = GdprReportsRepository.getAll();
        const gdprReportsObservable = GdprReportsRepository.getObservable();
        $scope.hasReport = true;
        $scope.brandName = CWCONFIG.partnerConfig.name;


        const onNextAction = () => {

            if ($rootScope.gdprReportTimestamp) {

                $scope.gdprReportTimestamp = $rootScope.gdprReportTimestamp;

            }

            if (GdprReports.length > 0) {

                $scope.hasReport = true;

            } else {

                $scope.hasReport = false;

            }

        };

        const mixpanelPayload = {
            Modal: 'GDPR Report',
            Page: Util.getPageName(),
        };

        Mixpanel.send('ConnectWeb Modal Open ', mixpanelPayload);

        const gdprReportsSubscriber =
            gdprReportsObservable.subscribe(onNextAction, () => { }, () => { });

        $scope.$on('$destroy', () => {

            gdprReportsSubscriber.dispose();

        });

        $scope.getReport = () => {

            const payload = {
                data: {
                    attributes: {
                        action_type: 'gdpr_get_data',
                    },
                },
            };

            Mixpanel.send('ConnectWeb Request Report Click');

            GdprActionsRestService.create(payload).then(() => {

                GdprActionsRestService.getAllAsync().then((response) => {

                    GdprActionsRepository.replace(response.data.data);

                });

                $state.go('root.dashboard.my-account.ltb', {
                    ltb: 'get-report',
                });

            }).then(null, (error) => {

                let errorReason;

                if (Util.deepFind(error, 'data.error')) {

                    errorReason = error.data.code;

                } else if (Util.deepFind(error, 'data.errors')) {

                    errorReason = error.data.errors[0].code;

                }

                if (errorReason === '1808') {

                    Alert.error('cw.get_report.already_requested_error');

                } else {

                    Alert.error('cw.get_report.error');

                }

            });

        };

        $scope.print = () => {

            Mixpanel.send('Connect Web GDPR Print Click');

        };

    }

}

_serviceDependencies.push(GdprReport);

angular.module('controllers')
    .controller('GdprReport', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/gdpr-report/gdpr-report.js